import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=2f54340a&scoped=true&"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=2f54340a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f54340a",
  null
  
)

export default component.exports